import 'typeface-montserrat'
import 'typeface-arvo'

export { wrapPageElement } from './gatsby-ssr'
